import { render, staticRenderFns } from "./AnnualSummaryBlockTableComponent.vue?vue&type=template&id=5f41b95a&scoped=true&"
import script from "./AnnualSummaryBlockTableComponent.vue?vue&type=script&lang=js&"
export * from "./AnnualSummaryBlockTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnnualSummaryBlockTableComponent.vue?vue&type=style&index=0&id=5f41b95a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41b95a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
